import React, { Children } from 'react';
import { motion } from 'framer-motion';
const audiences = [{
  emoji: '👩‍🍼',
  title: '1.- Mamás y papás primerizos',
  color: '#DA007C',
  bullets: ['No sabes si estás estimulando "lo suficiente"', 'Tienes miedo de hacerlo mal', 'Buscas orientación clara sin sobreinformación'],
  description: 'Este libro te guía paso a paso con actividades simples, explicadas y adaptadas a la edad real de tu hijo, para que tengas tranquilidad y confianza.'
}, {
  emoji: '👶',
  title: '2.- Padres con niños de 1 a 3 años que "se distraen rápido"',
  color: '#0096C7',
  bullets: ['Se aburre con facilidad', 'No logra concentrarse mucho tiempo', 'Pierde interés rápido en los juegos'],
  description: 'Las actividades están diseñadas para captar su atención de forma natural, respetando su etapa de desarrollo, sin forzarlo ni exigirle más de lo que puede dar.'
}, {
  emoji: '🗣️',
  title: '3.- Padres preocupados por el lenguaje',
  color: '#7B2CBF',
  bullets: ['Aún no hable mucho', 'No pronuncie bien algunas palabras', 'Tenga poco vocabulario para su edad'],
  description: 'Este material incluye actividades específicas para estimular lenguaje, comprensión y comunicación temprana, de manera lúdica y cotidiana.'
}, {
  emoji: '👩‍🏫',
  title: '4.- Educadoras, niñeras, abuelitos y docentes iniciales',
  color: '#2E8B57',
  bullets: ['Material listo para usar', 'Actividades variadas sin repetir siempre lo mismo', 'Recursos imprimibles para aula o casa'],
  description: 'Este libro te ahorra tiempo de planificación y te brinda un banco completo de actividades adaptadas a la primera infancia.'
}, {
  emoji: '👨‍👩‍👧',
  title: '5.- Familias con más de un niño pequeño',
  color: '#D00000',
  bullets: ['Puedes usar el material con todos', 'Adaptar las actividades según edad y ritmo', 'Imprimir solo lo que necesites'],
  description: 'Es una inversión que se aprovecha durante meses y con varios niños.'
}];
export function ParaQuienSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: 'easeOut'
      }
    }
  };
  return <section className="w-full px-4 py-8 md:py-16 bg-[#FFF9F1] overflow-hidden" data-id="element-121">
      <motion.div className="max-w-xl md:max-w-2xl mx-auto space-y-4" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
      once: true,
      amount: 0.1
    }} data-id="element-122">
        <motion.h2 variants={itemVariants} className="text-2xl md:text-3xl font-extrabold text-center text-[#003087] underline decoration-[#FFE600] decoration-4" data-id="element-123">
          🟤 ¿Para quién es este material?
        </motion.h2>

        {audiences.map((audience, index) => <motion.div key={index} variants={itemVariants} className="bg-white rounded-2xl p-4 md:p-6 shadow-md" data-id="element-124">
            <h3 className="text-lg md:text-xl font-semibold mb-2" style={{
          color: audience.color
        }} data-id="element-125">
              {audience.emoji} {audience.title}
            </h3>
            <ul className="list-disc pl-5 text-base md:text-lg space-y-1" data-id="element-126">
              {audience.bullets.map((bullet, i) => <li key={i} data-id="element-127">{bullet}</li>)}
            </ul>
            <p className="mt-2 text-sm md:text-base italic" data-id="element-128">
              {audience.description}
            </p>
          </motion.div>)}

        <motion.p variants={itemVariants} className="text-center text-black font-semibold text-sm md:text-base mt-4" data-id="element-129">
          Más de 5,600 familias, mamás y educadoras ya lo están utilizando con
          excelentes resultados.
        </motion.p>

        <motion.div variants={itemVariants} className="mt-2 flex justify-center" data-id="element-130">
          <img src="https://cdn.magicpatterns.com/uploads/bczazJqr5aUEwvGB9bDDXc/Evaluacion-general-de-Educando-Peques-¡Excelente-4.9-5-1.245-1.png" alt="Evaluación general de Educando Peques - Excelente 4.9/5" className="max-w-[260px] md:max-w-[320px] h-auto" data-id="element-131" />
        </motion.div>
      </motion.div>
    </section>;
}